// This function calculates the tax amount from a total value, based on the provided tax percentage
export const calculatePercentage = (total: number, taxPercentage: number): number => {
  return total * (taxPercentage / 100);
};

export const calculatePercentageValue = (value: number, total: number): number => {
  return (value / total) * 100;
};

export const calculatePercentageTotal = (value: number, taxPercentage: number): number => {
  return value / (taxPercentage / 100);
};

interface BoundingPoints {
  minLat: number;
  maxLat: number;
  maxLong: number;
  minLong: number;
}

function radiansToDegrees(radians: number) {
  return radians * (180 / Math.PI);
}

function roundDecimals(num: number) {
  return parseFloat(num.toFixed(7));
}

export function calculateBoundingPoints(centerPoint?: { lat: number; lng: number }): BoundingPoints {
  if (!centerPoint) return { minLat: 0, maxLat: 0, maxLong: 0, minLong: 0 };

  const R = 6371; // Radius of the Earth in km
  const radius = 50; // km
  const latitudeInRadians = centerPoint.lat * (Math.PI / 180);

  return {
    minLong: roundDecimals(centerPoint.lng - radiansToDegrees(radius / R / Math.cos(latitudeInRadians))),
    maxLong: roundDecimals(centerPoint.lng + radiansToDegrees(radius / R / Math.cos(latitudeInRadians))),
    minLat: roundDecimals(centerPoint.lat - radiansToDegrees(radius / R)),
    maxLat: roundDecimals(centerPoint.lat + radiansToDegrees(radius / R)),
  };
}
